module.exports = __webpack_public_path__ + "fonts/flUhRq6tzZclQEJ-Vdg-IuiaDsNa.84a37de8.84a37de8.woff";